import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { getFileSizeString, guardString } from "@msuite/utils/strings";
import type { FileInboxListItem } from "@msuite/utils/types";
import { FileOutcome } from "@/components/files";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<FileInboxListItem>();

export const columns = [
	columnHelper.accessor((row) => row.file.fileName, {
		id: "file-name",
		header: localized("files.file_name"),
		cell: (cell) => cell.getValue(),
		size: 320,
	}),
	columnHelper.accessor((row) => row.file.createdAt, {
		id: "dropped-at",
		header: localized("files.inbox_dropped_at"),
		cell: (cell) => moment(cell.getValue()).format("DD.MM.YYYY HH:mm"),
	}),
	columnHelper.accessor("uploadedByName", {
		id: "dropped-by",
		header: localized("files.inbox_dropped_by"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor((row) => row.file.size, {
		id: "size",
		header: localized("files.file_size"),
		cell: (cell) => getFileSizeString(cell.getValue()),
	}),
	// The classifier's own sentence, which is the whole reason this row is here rather than on a
	// record — and the thing that tells somebody whether to file it or to go and look at it first.
	// Rendered by the same component the batch report uses, so a file reads alike in both.
	columnHelper.accessor("reason", {
		id: "reason",
		header: localized("files.inbox_reason"),
		cell: (cell) => (
			<FileOutcome
				state={cell.row.original.state}
				reason={cell.row.original.reason}
				error={cell.row.original.error}
			/>
		),
		size: 420,
	}),
	createRowActions(RowActions),
];
